import { FC } from "react";
import UsersIcon from "@ht/shared/fonts/deos-pis/users-outline";
import ChatOutlineIcon from "@ht/shared/fonts/deos-pis/chat-outline";
import UserIcon from "@ht/shared/fonts/deos-pis/user-outline";

const Circle: FC = ({ children }) => {
    return <div className="rounded-full p-5 bg-primary-50">{children}</div>
}
const EmptyMessage: FC = () => {
    const threeDot = (
        <div className="mx-4 flex justify-center items-center ">
            <div className="min-w-[6px] min-h-[6px] rounded-full bg-primary" />
            <div className="min-w-[6px] min-h-[6px] rounded-full bg-primary mx-4" />
            <div className="min-w-[6px] min-h-[6px] rounded-full bg-primary" />
        </div>
    );
    return (
        <div className="flex flex-col items-center justify-center flex-auto">
            <div className="flex justify-center">
                <Circle><UsersIcon className="text-primary" height={44} width={45} /></Circle>
                {threeDot}
                <Circle><ChatOutlineIcon className="text-primary" /></Circle>
                {threeDot}
                <Circle><UserIcon className="text-primary" /></Circle>
            </div>
            <div className="text-gray-700 font-bold text-[20px] mt-8 ">
                arsi. Content Management
            </div>
            <div className=" mt-3 text-gray-400 text-md font-normal text-center">
                Accept or start a chat with other agents and communicate with your <br /> team.
            </div>
        </div>
    )
}

export default EmptyMessage;